module.exports = "/assets/3ab9bfbac5fac48619942a7c41de3399.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/B5.png
// module id = 2347
// module chunks = 0